import LiconicInstrumentPage from './LiconicInstrumentPage'

export default LiconicInstrumentPage
